import { useEffect, useState } from 'react';
import TreeView from '../shared/TreeView';
import { addPropAndValue, addToSelectedList } from '../shared/UtilFunctions';
import { Box, Grid, MenuItem, Select, Typography } from '@mui/material';

export default function MGCHierarchyFilter(props) {
  const {
    masterMGCJson,
    selectedMGCList,
    setParentFilterInfo,
    setSelectedMGCs,
    createMGC,
    register,
    setParentMgcData,
    isEdit,
    isEditMgc,
    showMgcError,
    isMgcEdited,
    selectedMgc,
    selectMgcJsonAfterEdit
  } = props;

  const [commodities, setCommodities] = useState([]);
  const [majors, setMajors] = useState([]);
  const [refreshMajors, setRefreshMajors] = useState(false);
  const [minors, setMinors] = useState([]);
  const [refreshMinors, setRefreshMinors] = useState(false);
  const [segments, setSegments] = useState([]);
  const [refreshSegments, setRefreshSegments] = useState(false);
  const [selectedCommodities, setSelectedCommodities] = useState();
  const [selectedMajors, setSelectedMajors] = useState();
  const [selectedMinors, setSelectedMinors] = useState();
  const [selectedSegments, setSelectedSegments] = useState();
  const [masterMinors, setMasterMinors] = useState();

  const [mgcsData, setMgcsData] = useState({});

  function getObjectForSelectComp(obj, childName, childObj) {
    let trasformedObj = {
      value: obj.code,
      label: obj.nameWithHierarchicalCode,
      desc: obj.name
    };
    if (childName) addPropAndValue(trasformedObj, childName, childObj);
    return trasformedObj;
  }

  function processTreeViewJson(minorsData) {
    if (minorsData) {
      let updatedObj = minorsData.map((minor) => {
        if (minor.segments) {
          addPropAndValue(minor, 'children', minor.segments);
        }

        return minor;
      });
      setMasterMinors(updatedObj);
    } else setMasterMinors([]);
  }

  function loadCommodities(masterData) {
    let list = [];

    masterData &&
      masterData.forEach((obj) =>
        list.push(getObjectForSelectComp(obj, 'majors', obj.majors))
      );
    setCommodities(list);
    return list;
  }
  function loadMajors(masterData) {
    let list = [];

    masterData &&
      masterData.forEach((obj) =>
        list.push(getObjectForSelectComp(obj, 'minors', obj.minors))
      );
    setMajors(list);
    setRefreshMajors(true);
    setRefreshMinors(true);
    setRefreshSegments(true);
    return list;
  }
  function loadMinors(masterData) {
    let list = [];

    masterData &&
      masterData.forEach((obj) =>
        list.push(getObjectForSelectComp(obj, 'segments', obj.segments))
      );
    setMinors(list);
    setRefreshMinors(true);
    setRefreshSegments(true);
    return list;
  }
  function loadSegments(masterData) {
    let list = [];

    masterData &&
      masterData.forEach((obj) => list.push(getObjectForSelectComp(obj)));
    setSegments(list);
    setRefreshSegments(true);
    return list;
  }

  const loadCommodityOptions = (inputValue, callback) => {
    callback(
      commodities.filter((i) =>
        i.label.toLowerCase().includes(inputValue.toLowerCase())
      )
    );
  };
  const loadMajorOptions = (inputValue, callback) => {
    callback(
      majors.filter((i) =>
        i.label.toLowerCase().includes(inputValue.toLowerCase())
      )
    );
  };
  const loadMinorOptions = (inputValue, callback) => {
    callback(
      minors.filter((i) =>
        i.label.toLowerCase().includes(inputValue.toLowerCase())
      )
    );
  };
  const loadSegmentOptions = (inputValue, callback) => {
    callback(
      segments.filter((i) =>
        i.label.toLowerCase().includes(inputValue.toLowerCase())
      )
    );
  };

  function addProperty(propObject, propName, propValues) {
    if (propObject && propName && propValues && propValues.length > 0)
      addPropAndValue(propObject, propName, propValues);
  }
  function createSelectedOptionListWithLabel(obj) {
    let stringWithLabel = '',
      selectedOptionCode = [];

    if (obj) {
      stringWithLabel = stringWithLabel + obj.label + ',';
      selectedOptionCode.push(obj.value);
    }
    return {
      label: stringWithLabel,
      codes: selectedOptionCode
    };
  }
  const handleInputChange = () => {
    let list = [];
    let selectedCommodityLabelAndCode =
      createSelectedOptionListWithLabel(selectedCommodities);
    let selectedMajorLabelAndCode =
      createSelectedOptionListWithLabel(selectedMajors);
    let selectedMinorLabelAndCode =
      createSelectedOptionListWithLabel(selectedMinors);
    let selectedSegmentLabelAndCode =
      createSelectedOptionListWithLabel(selectedSegments);
    let showOnIndivLines = false;

    if (showOnIndivLines) {
      addToSelectedList(list, selectedCommodityLabelAndCode.label, 'Commodity');
      addToSelectedList(list, selectedMajorLabelAndCode.label, 'Major');
      addToSelectedList(list, selectedMinorLabelAndCode.label, 'Minor');
      addToSelectedList(list, selectedSegmentLabelAndCode.label, 'Segment');
    } else {
      // Show Consolidated

      let label = '';
      let code = '';

      if (selectedCommodityLabelAndCode.label !== '') {
        label = selectedCommodities.desc;
        code = selectedCommodities.value;
        if (selectedMajorLabelAndCode.label !== '') {
          label += ' ' + selectedMajors.desc;
          code += ' ' + selectedMajors.value;
          if (selectedMinorLabelAndCode.label !== '') {
            label += ' ' + selectedMinors.desc;
            code += ' ' + selectedMinors.value;
            if (selectedSegmentLabelAndCode.label !== '') {
              label += ' ' + selectedSegments.desc;
              code += ' ' + selectedSegments.value;
            }
          }
        }
      }

      addToSelectedList(list, label, code, true);
    }

    // Set For the Control to show in collapsed view
    setSelectedMGCs && setSelectedMGCs(list);

    let json = {};

    addProperty(json, 'commodities', selectedCommodityLabelAndCode.codes);
    addProperty(json, 'majors', selectedMajorLabelAndCode.codes);
    addProperty(json, 'minors', selectedMinorLabelAndCode.codes);
    addProperty(json, 'segments', selectedSegmentLabelAndCode.codes);
    // Set on Parent
    setParentFilterInfo && setParentFilterInfo(json);
  };

  function prepareList(masterList, inputList, useCode) {
    let list = [];
    inputList.forEach((item) => {
      list.push(
        masterList.filter((i) =>
          (useCode ? i.code : i.value)
            .toLowerCase()
            .includes(item.toLowerCase())
        )[0]
      );
    });
    return list;
  }

  function prepareListForMgcEdit(masterList, inputCommodityOrMajor) {
    let list = [];
    masterList.forEach((item) =>
      item.value.toLowerCase().includes(inputCommodityOrMajor.toLowerCase())
        ? list.push(item)
        : ''
    );
    return list;
  }

  function resetSegments() {
    setSelectedSegments(null);
    setSegments([]);
  }
  function resetMinors() {
    setSelectedMinors(null);
    setMinors([]);
    resetSegments();
    setMasterMinors([]);
  }
  function resetMajors() {
    setSelectedMajors(null);
    setMajors([]);
    resetMinors();
  }

  useEffect(() => {
    if (selectedCommodities) loadMajors(selectedCommodities.majors);
  }, [selectedCommodities]);
  useEffect(() => {
    setRefreshMajors(false);
  }, [refreshMajors]);
  useEffect(() => {
    // Load Commodities (Start here)
    loadCommodities(masterMGCJson);
  }, [masterMGCJson]);

  useEffect(() => {
    if (selectedMajors) {
      if (createMGC) processTreeViewJson(selectedMajors.minors);
      else loadMinors(selectedMajors.minors);
    }
  }, [selectedMajors]);
  useEffect(() => {
    setRefreshMinors(false);
  }, [refreshMinors]);

  useEffect(() => {
    if (selectedMinors) loadSegments(selectedMinors.segments);
  }, [selectedMinors]);
  useEffect(() => {
    setRefreshSegments(false);
  }, [refreshSegments]);

  useEffect(() => {
    if (
      selectedMGCList &&
      commodities &&
      commodities.length > 0 &&
      selectedMGCList.commodities
    ) {
      // Load the selections passed from parent

      let list = isMgcEdited
        ? selectedMgc && selectedMgc.commodity
          ? prepareListForMgcEdit(commodities, '' + selectedMgc.commodity.value)
          : null
        : prepareList(commodities, selectedMGCList.commodities);

      setSelectedCommodities(list && list.length > 0 ? list[0] : null);
      if (isMgcEdited && selectedMgc && selectedMgc.major) {
        let dataObj = addToParentState(
          'commodity',
          list && list.length > 0 ? list[0] : null
        );
        let metaList =
          list && list.length > 0 ? loadMajors(list[0].majors) : null;
        if (metaList != null && selectedMgc.major.value) {
          list = prepareListForMgcEdit(metaList, '' + selectedMgc.major.value);
          setSelectedMajors(list[0]);
          setParentState('major', list[0], dataObj);
        } else {
          setSelectedMajors(null);
        }
      } else {
        if (selectedMGCList.majors) {
          let dataObj = addToParentState('commodity', list[0]);
          let metaList = loadMajors(list[0].majors);

          list = prepareList(metaList, selectedMGCList.majors);

          setSelectedMajors(list[0]);
          setParentState('major', list[0], dataObj);

          if (selectedMGCList.minors) {
            metaList = loadMinors(list[0].minors);

            list = prepareList(metaList, selectedMGCList.minors);
            setSelectedMinors(list[0]);

            if (selectedMGCList.segments) {
              metaList = loadSegments(list[0].segments);
              list = prepareList(metaList, selectedMGCList.segments);
              setSelectedSegments(list[0]);
            }
          }
        } else setParentState('commodity', list[0]);
      }
    }
  }, [commodities, selectedMGCList]);

  useEffect(() => {
    if (!createMGC) handleInputChange();
  }, [selectedCommodities, selectedMajors, selectedMinors, selectedSegments]);

  function notSame(oldVal, newVal) {
    return !oldVal || !newVal || oldVal.value !== newVal.value;
  }
  function commodityChange(value, event) {
    if (notSame(selectedCommodities, value)) {
      resetMajors();
      let data = addToParentState('major', null, null);
      data = addToParentState('minorSegments', null, data);
      setSelectedCommodities(value);
      setParentState('commodity', value, data, event);
    }
  }

  function majorChange(value, event) {
    if (notSame(selectedMajors, value)) {
      resetMinors();
      setSelectedMajors(value);
      setParentState('major', value, null, event);
    }
  }

  function setMinorSegments(minorSegmentData, isDirty) {
    if (minorSegmentData && minorSegmentData.length > 0) {
      setParentState('minorSegments', minorSegmentData, null, isDirty);
    }
  }

  function addToParentState(name, value, dataObj) {
    let data = dataObj ? dataObj : { ...mgcsData };

    addPropAndValue(data, name, value);
    return data;
  }
  function setParentState(name, value, dataObj, event) {
    let data = addToParentState(name, value, dataObj);

    setMgcsData(data);
    setParentMgcData && setParentMgcData(data, event);
  }

  return createMGC ? (
    <Box>
      <Grid container spacing={2} sx={{ mb: 0 }}>
        <Grid size={6}>
          <Typography sx={{ display: 'block', fontWeight: 'bold' }}>
            Commodity{' '}
            <Box
              component="span"
              aria-label="required field"
              sx={{ color: 'error.main' }}
            >
              *
            </Box>
          </Typography>
          <Select
            value={selectedCommodities?.value ?? ''}
            displayEmpty
            fullWidth
            size="small"
            error={!selectedCommodities && showMgcError}
            renderValue={(selected) =>
              selected ? (
                (commodities.find((c) => c.value === selected)?.label ??
                selected)
              ) : (
                <em>Select</em>
              )
            }
            onChange={(event) => {
              const obj =
                commodities.find((c) => c.value === event.target.value) ?? null;
              commodityChange(obj, event);
            }}
          >
            <MenuItem value="">
              <em>Select</em>
            </MenuItem>
            {commodities.map((c) => (
              <MenuItem key={c.value} value={c.value}>
                {c.label}
              </MenuItem>
            ))}
          </Select>
        </Grid>

        <Grid size={6}>
          <Typography sx={{ display: 'block', fontWeight: 'bold' }}>
            Major
            <Box
              component="span"
              aria-label="required field"
              sx={{
                color: 'error.main',
                ml: (theme) => theme.fuel6Tokens.JddcSpacingXSmall
              }}
            >
              *
            </Box>
          </Typography>
          <Select
            value={selectedMajors?.value ?? ''}
            displayEmpty
            fullWidth
            size="small"
            disabled={majors.length === 0}
            error={!selectedMajors && showMgcError}
            renderValue={(selected) =>
              selected ? (
                (majors.find((m) => m.value === selected)?.label ?? selected)
              ) : (
                <em>Select</em>
              )
            }
            onChange={(event) => {
              const obj =
                majors.find((m) => m.value === event.target.value) ?? null;
              majorChange(obj, event);
            }}
          >
            <MenuItem value="">
              <em>Select</em>
            </MenuItem>
            {majors.map((m) => (
              <MenuItem key={m.value} value={m.value}>
                {m.label}
              </MenuItem>
            ))}
          </Select>
        </Grid>
      </Grid>
      <Box>
        {masterMinors && masterMinors.length > 0 && (
          <TreeView
            masterInputTreeJson={masterMinors}
            showInOneColumn={true}
            showFilter={false}
            filterPlaceHolder="Filter this list"
            donotShowClearButton={true}
            selectAll={true}
            addVScrollBar={true}
            createMGC={true}
            firstLevelLabel={'Minor'}
            secondLevelLabel={'Segment'}
            register={register}
            setParentMasterData={setMinorSegments}
            rpcOrUnitsFromParent={
              selectMgcJsonAfterEdit ? selectMgcJsonAfterEdit : selectedMGCList
            }
            isEdit={isEdit}
            mgcsData={mgcsData}
          />
        )}
      </Box>
    </Box>
  ) : (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        gap: theme.fuel6Tokens.JddcSpacingSmall
      })}
    >
      <Select
        value={selectedCommodities?.value ?? ''}
        displayEmpty
        fullWidth
        size="small"
        renderValue={(selected) =>
          selected
            ? (commodities.find((c) => c.value === selected)?.label ?? selected)
            : 'Commodity'
        }
        onChange={(event) => {
          const obj =
            commodities.find((c) => c.value === event.target.value) ?? null;
          if (notSame(selectedCommodities, obj)) {
            resetMajors();
            setSelectedCommodities(obj);
          }
        }}
      >
        <MenuItem value="">Commodity</MenuItem>
        {commodities.map((c) => (
          <MenuItem key={c.value} value={c.value}>
            {c.label}
          </MenuItem>
        ))}
      </Select>
      <Select
        value={selectedMajors?.value ?? ''}
        displayEmpty
        fullWidth
        size="small"
        disabled={majors.length === 0}
        renderValue={(selected) =>
          selected
            ? (majors.find((m) => m.value === selected)?.label ?? selected)
            : 'Major'
        }
        onChange={(event) => {
          const obj =
            majors.find((m) => m.value === event.target.value) ?? null;
          if (notSame(selectedMajors, obj)) {
            resetMinors();
            setSelectedMajors(obj);
          }
        }}
      >
        <MenuItem value="">Major</MenuItem>
        {majors.map((m) => (
          <MenuItem key={m.value} value={m.value}>
            {m.label}
          </MenuItem>
        ))}
      </Select>
      <Select
        value={selectedMinors?.value ?? ''}
        displayEmpty
        fullWidth
        size="small"
        disabled={minors.length === 0}
        renderValue={(selected) =>
          selected
            ? (minors.find((mn) => mn.value === selected)?.label ?? selected)
            : 'Minor'
        }
        onChange={(event) => {
          const obj =
            minors.find((mn) => mn.value === event.target.value) ?? null;
          if (notSame(selectedMinors, obj)) {
            resetSegments();
            setSelectedMinors(obj);
          }
        }}
      >
        <MenuItem value="">Minor</MenuItem>
        {minors.map((mn) => (
          <MenuItem key={mn.value} value={mn.value}>
            {mn.label}
          </MenuItem>
        ))}
      </Select>
      <Select
        value={selectedSegments?.value ?? ''}
        displayEmpty
        fullWidth
        size="small"
        disabled={segments.length === 0}
        renderValue={(selected) =>
          selected
            ? (segments.find((s) => s.value === selected)?.label ?? selected)
            : 'Segment'
        }
        onChange={(event) => {
          const obj =
            segments.find((s) => s.value === event.target.value) ?? null;
          setSelectedSegments(obj);
        }}
      >
        <MenuItem value="">Segment</MenuItem>
        {segments.map((s) => (
          <MenuItem key={s.value} value={s.value}>
            {s.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
